import { render } from "./SkeletonNFTCard.vue?vue&type=template&id=d0a044f6&scoped=true"
import script from "./SkeletonNFTCard.vue?vue&type=script&lang=js"
export * from "./SkeletonNFTCard.vue?vue&type=script&lang=js"

import "./SkeletonNFTCard.vue?vue&type=style&index=0&id=d0a044f6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0a044f6"]])

export default __exports__